var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPackage3NuMedium = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 62,
    viewBox: "0 0 135 62",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h135v62H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1E2969"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.772 16.622h18.544v36.315H48.772z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.657 10.228h15.455v42.71H59.657zM78.78 23.263h14.708v29.675H78.78zM30.067 27.694h16.742v25.243H30.067z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.046 18.321h12.226v34.617H76.046zM26.866 24.674h9.015V52.94h-9.015zM95.462 30.397h11.45v22.54h-11.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.662 36.537h8.33v16.401h-8.33zM21.008 36.537h8.33v16.401h-8.33z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD8F7E",
    d: "M39.484 36.392h56.032v16.524H39.484z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9C4B9",
    d: "M39 50.985h56.998v1.925H39z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M95.486 33.39H39.514l-.997 3.065h57.964zM78.297 38.197h2.608v4.586h-2.608z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M80.904 42.785h-2.605l-.153 1.136h2.908z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.759 4.585H.15V3.492L2.759.965z",
    transform: "translate(78.146 38.197)"
  }), /*#__PURE__*/React.createElement("g", null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M81.925 38.197h2.608v4.586h-2.608z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M84.532 42.785h-2.605l-.15 1.136h2.905z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.757 4.585H.15V3.492L2.757.965z",
    transform: "translate(81.776 38.197)"
  })), /*#__PURE__*/React.createElement("g", null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M86.727 38.197h2.608v4.586h-2.608z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M89.332 42.785h-2.605l-.15 1.136h2.907z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.759 4.585H.15V3.492L2.759.965z",
    transform: "translate(86.576 38.197)"
  }), /*#__PURE__*/React.createElement("g", null, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M90.355 38.197h2.608v4.586h-2.608z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M92.96 42.785h-2.605l-.15 1.136h2.907z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.759 4.585H.15V3.492L2.759.965z",
    transform: "translate(90.204 38.197)"
  }))), /*#__PURE__*/React.createElement("g", null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M78.297 44.684h2.608v4.586h-2.608z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M80.904 49.273h-2.605l-.153 1.137h2.908z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.759 4.585H.15V3.492L2.759.965z",
    transform: "translate(78.146 44.684)"
  }), /*#__PURE__*/React.createElement("g", null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M81.925 44.684h2.608v4.586h-2.608z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M84.532 49.273h-2.605l-.15 1.137h2.905z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.757 4.585H.15V3.492L2.757.965z",
    transform: "translate(81.776 44.684)"
  })), /*#__PURE__*/React.createElement("g", null, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M86.727 44.684h2.608v4.586h-2.608z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M89.332 49.273h-2.605l-.15 1.137h2.907z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.759 4.585H.15V3.492L2.759.965z",
    transform: "translate(86.576 44.684)"
  }), /*#__PURE__*/React.createElement("g", null, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M90.355 44.684h2.608v4.586h-2.608z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M92.96 49.273h-2.605l-.15 1.137h2.907z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.759 4.585H.15V3.492L2.759.965z",
    transform: "translate(90.204 44.684)"
  })))), /*#__PURE__*/React.createElement("g", null, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M42.037 38.197h2.608v4.586h-2.608z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M44.643 42.785h-2.605l-.15 1.136h2.908z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.759 4.585H.149V3.492L2.76.965z",
    transform: "translate(41.888 38.197)"
  }), /*#__PURE__*/React.createElement("g", null, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M45.665 38.197h2.608v4.586h-2.608z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M48.271 42.785h-2.604l-.151 1.136h2.908z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.759 4.585H.149V3.492L2.76.965z",
    transform: "translate(45.516 38.197)"
  })), /*#__PURE__*/React.createElement("g", null, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M50.467 38.197h2.608v4.586h-2.608z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M53.073 42.785h-2.606l-.15 1.136h2.907z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.759 4.585H.15V3.492L2.759.965z",
    transform: "translate(50.316 38.197)"
  }), /*#__PURE__*/React.createElement("g", null, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M54.095 38.197h2.608v4.586h-2.608z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M56.701 42.785h-2.606l-.15 1.136h2.907z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.759 4.585H.15V3.492L2.759.965z",
    transform: "translate(53.944 38.197)"
  }))), /*#__PURE__*/React.createElement("g", null, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M42.037 44.684h2.608v4.586h-2.608z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M44.643 49.273h-2.605l-.15 1.137h2.908z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.759 4.585H.149V3.492L2.76.965z",
    transform: "translate(41.888 44.684)"
  }), /*#__PURE__*/React.createElement("g", null, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M45.665 44.684h2.608v4.586h-2.608z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M48.271 49.273h-2.604l-.151 1.137h2.908z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.759 4.585H.149V3.492L2.76.965z",
    transform: "translate(45.516 44.684)"
  })), /*#__PURE__*/React.createElement("g", null, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M50.467 44.684h2.608v4.586h-2.608z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M53.073 49.273h-2.606l-.15 1.137h2.907z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.759 4.585H.15V3.492L2.759.965z",
    transform: "translate(50.316 44.684)"
  }), /*#__PURE__*/React.createElement("g", null, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M54.095 44.684h2.608v4.586h-2.608z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M56.701 49.273h-2.606l-.15 1.137h2.907z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.759 4.585H.15V3.492L2.759.965z",
    transform: "translate(53.944 44.684)"
  }))))), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C5",
    opacity: 0.55,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M.967 3.069h56.032v1.137H.967z",
    transform: "translate(38.517 33.39)"
  }), /*#__PURE__*/React.createElement("g", null, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M56.938 31.398 67.5 22.754l10.561 8.644z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M76.194 52.93H58.806V31.395l8.693-7.15 8.695 7.15z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD8F7E",
    d: "M61.22 43.3h12.56v9.631H61.22z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9C9B9B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.282 20.643v9.532h.58v-9.191H16.26v9.191h.581v-9.532z",
    transform: "translate(56.938 22.754)"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9DFD1",
    d: "M58.322 41.94h18.355v1.457H58.322z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M70.99 47.564c-.067-1.37-1.603-2.465-3.49-2.465-1.889 0-3.425 1.096-3.492 2.465l-.003 5.36h6.989l-.003-5.36z",
    fill: "#9A5238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.496 7.825H6.99l-.003-5.36C6.92 1.094 5.382 0 3.496 0v7.825z",
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(64.005 45.1)"
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M69.433 29.526a1.937 1.937 0 0 1-1.932 1.943 1.937 1.937 0 0 1-1.932-1.943c0-1.074.865-1.944 1.932-1.944s1.932.87 1.932 1.944z",
    fill: "#BD8F7E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M69.023 29.526c0 .846-.681 1.531-1.522 1.531a1.526 1.526 0 0 1-1.522-1.531c0-.846.68-1.532 1.522-1.532.84 0 1.522.686 1.522 1.532z",
    fill: "#F9DFD1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M60.751 33.54h2.608v6.335h-2.608z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09484",
    d: "M63.358 39.878h-2.605l-.15 1.137h2.906z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929191",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.757 6.334H.15V5.242l2.608-2.528z",
    transform: "translate(60.602 33.54)"
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M64.38 33.54h2.608v6.335H64.38z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09484",
    d: "M66.986 39.878h-2.605l-.15 1.137h2.906z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929191",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.757 6.334H.15V5.242l2.608-2.528z",
    transform: "translate(64.23 33.54)"
  }), /*#__PURE__*/React.createElement("g", null, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M68.008 33.54h2.608v6.335h-2.608z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09484",
    d: "M70.614 39.878H68.01l-.15 1.137h2.906z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929191",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.757 6.334H.15V5.242l2.608-2.528z",
    transform: "translate(67.859 33.54)"
  })), /*#__PURE__*/React.createElement("g", null, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M71.636 33.54h2.608v6.336h-2.608z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09484",
    d: "M74.242 39.878h-2.605l-.15 1.137h2.906z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD8F7E",
    d: "M71.64 34.352h2.607l.15-1.136H71.49zM68.012 34.352h2.607l.15-1.136h-2.907zM64.384 34.352h2.607l.15-1.136h-2.907zM60.756 34.352h2.607l.15-1.136h-2.907z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929191",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M13.638 6.658H11.03V5.565l2.608-2.527z",
    transform: "translate(60.606 33.216)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    },
    d: "m1.869 9.204 8.692-7.152 8.692 7.154.003-.573-8.695-7.152-8.694 7.152z",
    transform: "translate(56.938 22.754)"
  }), /*#__PURE__*/React.createElement("g", null, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9DFD1",
    d: "M73.553 50.236h2.898v2.693h-2.898zM73.563 43.408h2.898v2.248h-2.898z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9C9B9B",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0 0h2.898v2.248H0z",
    transform: "translate(73.563 43.408)"
  }), /*#__PURE__*/React.createElement("g", null, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9DFD1",
    d: "M58.539 50.236h2.898v2.693h-2.898zM58.548 43.408h2.898v2.248h-2.898z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9C9B9B",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0 0h2.898v2.248H0z",
    transform: "translate(58.548 43.408)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M53.979 20.394h1.13v32.545h-1.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9 23.63c-1.968 1.349-3.938-1.348-5.906 0v-3.37c1.968-1.348 3.938 1.348 5.905 0v3.37z",
    fill: "#F6C760"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m33.354 49.108-.282-.128c-.166.37-.647 1.223-1.196 1.533-.152.06-.198-.114-.207-.243v-1.443h-.557v1.452c-.011.136-.064.31-.235.218-.537-.324-1.005-1.15-1.168-1.517l-.282.128c.028.063.607 1.343 1.421 1.727.182.093.244.37.264.565v1.54h.557v-1.527c.019-.198.08-.485.268-.577h-.006c.814-.382 1.394-1.662 1.422-1.727l.001-.001z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.338 46.886a1.586 1.586 0 0 0-1.568-1.808h-.026a1.581 1.581 0 0 0-1.354-.767c-.575 0-1.077.308-1.355.768h-.026a1.586 1.586 0 0 0-1.568 1.807 1.595 1.595 0 0 0 1.132 2.703c.467 0 .888-.203 1.178-.529a1.565 1.565 0 0 0 1.277 0c.29.326.71.53 1.179.53.874 0 1.582-.713 1.582-1.592 0-.433-.171-.824-.45-1.112z",
    fill: "#80C134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.207 49.278a1.58 1.58 0 0 1-1.179-.529 1.565 1.565 0 0 1-1.277 0c-.29.326-.71.53-1.178.53-.823 0-1.498-.63-1.574-1.438a1.586 1.586 0 0 0 1.574 1.748c.467 0 .888-.203 1.178-.529a1.565 1.565 0 0 0 1.277 0c.29.326.71.53 1.179.53a1.586 1.586 0 0 0 1.574-1.749 1.585 1.585 0 0 1-1.574 1.437z",
    fill: "#528C10"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m100.406 47.447-.374-.17c-.22.493-.856 1.622-1.583 2.033-.202.079-.262-.152-.274-.322v-1.914h-.738V49c-.016.18-.086.41-.312.287-.713-.428-1.331-1.527-1.546-2.01l-.373.17c.037.083.805 1.78 1.884 2.287.242.125.322.49.349.748v2.454h.737v-2.438c.025-.26.105-.643.356-.764h-.008c1.08-.507 1.847-2.204 1.885-2.288l-.003.002z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.71 44.504a2.103 2.103 0 0 0-2.076-2.395h-.036a2.09 2.09 0 0 0-3.587 0h-.037a2.103 2.103 0 0 0-2.076 2.395c-.368.38-.596.9-.596 1.473 0 1.165.938 2.11 2.097 2.11.62 0 1.176-.272 1.56-.702a2.073 2.073 0 0 0 1.693 0c.384.431.941.701 1.56.701a2.103 2.103 0 0 0 2.097-2.11 2.11 2.11 0 0 0-.596-1.472h-.003z",
    fill: "#80C134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.21 47.674c-.62 0-1.177-.271-1.562-.7a2.073 2.073 0 0 1-1.691 0 2.086 2.086 0 0 1-1.562.7 2.1 2.1 0 0 1-2.085-1.904 2.103 2.103 0 0 0 2.087 2.316c.62 0 1.177-.271 1.561-.7a2.073 2.073 0 0 0 1.692 0c.384.43.942.7 1.561.7a2.103 2.103 0 0 0 2.087-2.316 2.102 2.102 0 0 1-2.085 1.904h-.003z",
    fill: "#528C10"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m39.705 46.847-.417-.188c-.245.55-.954 1.808-1.766 2.266-.226.088-.293-.17-.306-.359v-2.131h-.822v2.145c-.017.2-.096.457-.348.32-.794-.476-1.483-1.7-1.723-2.24l-.418.188c.043.095.896 1.987 2.1 2.55.27.14.36.548.389.835v2.706h.822v-2.688c.028-.29.118-.715.397-.853h-.008c1.204-.565 2.06-2.456 2.1-2.551z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.158 43.566a2.344 2.344 0 0 0-2.315-2.67h-.039a2.33 2.33 0 0 0-3.998 0h-.04a2.344 2.344 0 0 0-2.314 2.67 2.35 2.35 0 0 0-.665 1.642 2.344 2.344 0 0 0 2.336 2.35c.69 0 1.312-.3 1.74-.78a2.322 2.322 0 0 0 1.887 0c.428.48 1.048.78 1.74.78a2.344 2.344 0 0 0 2.337-2.35c0-.64-.255-1.217-.666-1.642h-.003z",
    fill: "#80C134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.487 47.098c-.69 0-1.312-.302-1.74-.782a2.322 2.322 0 0 1-1.887 0 2.324 2.324 0 0 1-1.74.782 2.343 2.343 0 0 1-2.325-2.122 2.344 2.344 0 0 0 2.326 2.581c.69 0 1.311-.301 1.74-.781a2.322 2.322 0 0 0 1.886 0c.428.48 1.048.781 1.74.781a2.344 2.344 0 0 0 2.325-2.581 2.343 2.343 0 0 1-2.325 2.122z",
    fill: "#528C10"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPackage3NuMedium);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/package-3nu-medium.17f86bc6e56f979d6ca2466b12e76ea7.svg";